(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vera-editorial-about"] && !Shopify.designMode) return;
  try {
    
  const veraEditorialVideoSelector = '.vera-editorial-card__inline-player';

  const pauseOtherEditorialVideos = (activeVideo) => {
    document.querySelectorAll(veraEditorialVideoSelector).forEach((video) => {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  };

  document.addEventListener(
    'play',
    (event) => {
      if (!event.target.matches(veraEditorialVideoSelector)) return;
      pauseOtherEditorialVideos(event.target);
    },
    true
  );

  const veraEditorialVideoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
      });
    },
    { threshold: 0.01 }
  );

  const observeEditorialVideos = (root) => {
    root.querySelectorAll(veraEditorialVideoSelector).forEach((video) => {
      if (video.dataset.veraViewportPause === 'true') return;
      video.dataset.veraViewportPause = 'true';
      veraEditorialVideoObserver.observe(video);
    });
  };

  observeEditorialVideos(document);

  document.addEventListener('shopify:section:load', (event) => {
    observeEditorialVideos(event.target);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    document.querySelectorAll(veraEditorialVideoSelector).forEach((video) => video.pause());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vera-fit-coming-soon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-vera-fit-launch]');
    if (!root) return;

    const deadline = Date.parse(root.dataset.deadline);
    const nodes = {
      days: root.querySelector('[data-days]'),
      hours: root.querySelector('[data-hours]'),
      minutes: root.querySelector('[data-minutes]'),
      seconds: root.querySelector('[data-seconds]')
    };

    const updateNode = (node, value) => {
      const next = String(value).padStart(2, '0');
      if (node.textContent === next) return;
      node.textContent = next;
      node.classList.remove('is-ticking');
      void node.offsetWidth;
      node.classList.add('is-ticking');
    };

    const tick = () => {
      const remaining = Math.max(0, deadline - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      updateNode(nodes.days, Math.floor(totalSeconds / 86400));
      updateNode(nodes.hours, Math.floor(totalSeconds / 3600) % 24);
      updateNode(nodes.minutes, Math.floor(totalSeconds / 60) % 60);
      updateNode(nodes.seconds, totalSeconds % 60);
    };

    tick();
    window.setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
